__turbopack_context__.v({
  "accordionControl": "LearningFormat-module__d7sQBG__accordionControl",
  "accordionControlInner": "LearningFormat-module__d7sQBG__accordionControlInner",
  "accordionItem": "LearningFormat-module__d7sQBG__accordionItem",
  "accordionLabel": "LearningFormat-module__d7sQBG__accordionLabel",
  "accordionRoot": "LearningFormat-module__d7sQBG__accordionRoot",
  "campusPriceButton": "LearningFormat-module__d7sQBG__campusPriceButton",
  "detailsCollapse": "LearningFormat-module__d7sQBG__detailsCollapse",
  "formatDescription": "LearningFormat-module__d7sQBG__formatDescription",
  "formatDetailSection": "LearningFormat-module__d7sQBG__formatDetailSection",
  "formatFactDescription": "LearningFormat-module__d7sQBG__formatFactDescription",
  "formatHeader": "LearningFormat-module__d7sQBG__formatHeader",
  "formatHeaderContent": "LearningFormat-module__d7sQBG__formatHeaderContent",
  "formatHeaderTop": "LearningFormat-module__d7sQBG__formatHeaderTop",
  "formatIcon": "LearningFormat-module__d7sQBG__formatIcon",
  "formatShortDescription": "LearningFormat-module__d7sQBG__formatShortDescription",
  "formatTitle": "LearningFormat-module__d7sQBG__formatTitle",
  "formatWhyChoose": "LearningFormat-module__d7sQBG__formatWhyChoose",
  "mobileAccordionControl": "LearningFormat-module__d7sQBG__mobileAccordionControl",
  "mobileAccordionItem": "LearningFormat-module__d7sQBG__mobileAccordionItem",
  "mobileAccordionRoot": "LearningFormat-module__d7sQBG__mobileAccordionRoot",
  "mobileBody": "LearningFormat-module__d7sQBG__mobileBody",
  "mobileCardFrame": "LearningFormat-module__d7sQBG__mobileCardFrame",
  "mobileOption": "LearningFormat-module__d7sQBG__mobileOption",
  "mobileOptionCard": "LearningFormat-module__d7sQBG__mobileOptionCard",
  "modalityFootnote": "LearningFormat-module__d7sQBG__modalityFootnote",
  "pricePrimary": "LearningFormat-module__d7sQBG__pricePrimary",
  "priceSecondary": "LearningFormat-module__d7sQBG__priceSecondary",
  "priceStack": "LearningFormat-module__d7sQBG__priceStack",
  "priceTertiary": "LearningFormat-module__d7sQBG__priceTertiary",
  "priceTertiaryUnavailable": "LearningFormat-module__d7sQBG__priceTertiaryUnavailable",
  "priceUnavailable": "LearningFormat-module__d7sQBG__priceUnavailable",
  "priceUnavailableIcon": "LearningFormat-module__d7sQBG__priceUnavailableIcon",
  "stickyHeader": "LearningFormat-module__d7sQBG__stickyHeader",
  "stickySentinel": "LearningFormat-module__d7sQBG__stickySentinel",
  "whyChoosePhone": "LearningFormat-module__d7sQBG__whyChoosePhone",
  "whyChooseTablet": "LearningFormat-module__d7sQBG__whyChooseTablet",
});
